module.exports = __webpack_public_path__ + "img/taxi-yes.c1538b3e.png";